import { forwardRef } from 'react';

import { cn } from './cn.js';

import type { InputHTMLAttributes } from 'react';

interface GlassInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string | undefined;
}

export const GlassInput = forwardRef<HTMLInputElement, GlassInputProps>(
  ({ label, error, className, id, ...props }, ref) => {
    const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-');

    return (
      <div className="flex flex-col gap-1.5">
        {label !== undefined && label !== '' && (
          <label htmlFor={inputId} className="text-sm font-medium text-text-secondary">
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            'h-9 px-3 rounded-lg text-text text-sm',
            'bg-[var(--glass-bg)] border border-[var(--glass-border)]',
            'backdrop-blur-[var(--glass-blur-subtle)]',
            'placeholder:text-text-tertiary',
            'transition-all duration-[var(--dur)] ease-[var(--ease)]',
            'hover:bg-[var(--glass-bg-hover)] hover:border-[var(--glass-border)]',
            'focus:outline-none focus:ring-2 focus:ring-ring focus:border-primary',
            'focus:shadow-[var(--glass-glow)]',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            error !== undefined && error !== '' && 'border-danger focus:ring-danger/30',
            className,
          )}
          {...props}
        />
        {error !== undefined && error !== '' && <p className="text-xs text-danger">{error}</p>}
      </div>
    );
  },
);
